export const USERCENTRICS_SETTINGS_IDS = {
  zaun24_at: 'CDMSBmxXd',
  zaun24_de: 'N-IPWS4uj'
}

export function usercentricsSettingsId (storeCode) {
  return storeCode === 'zaun24_at'
    ? USERCENTRICS_SETTINGS_IDS.zaun24_at
    : USERCENTRICS_SETTINGS_IDS.zaun24_de
}

export function usercentricsScriptTag (storeCode) {
  const settingsId = usercentricsSettingsId(storeCode)
  return `<script id="usercentrics-cmp" src="https://web.cmp.usercentrics.eu/ui/loader.js" data-settings-id="${settingsId}" data-tcf-enabled="true" async></script>`
}
